// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","breadcrumbs":"breadcrumbs_breadcrumbs__y8rnV"};